// Agent studio agent that does site mappings
export const CONSENT_AGENT_ID = 'c7e7b4cf-a999-414e-b7fc-b269b9c30a36';
// This agent is a lighter version of the consent agent that only returns the normalized spreadsheet contents.
export const CONSENT_LIGHT_AGENT_ID = 'a5ff9033-71b1-4481-93d7-03c7b5335c59';
/** Agent Studio agent that analyzes PDFs and returns `<results>` JSON (signature field regions). */
export const SIGNATURE_FIELD_AGENT_ID = 'ec5ea263-4c4a-459e-8ea1-85bc7914c25b';
export const SIGNATURE_FIELD_ANALYZE_PROMPT = 'analyze this file as directed';
export function isConsentLightResponse(data) {
    if (data === null || typeof data !== 'object' || !('assignments' in data)) {
        return false;
    }
    const { assignments } = data;
    return Array.isArray(assignments);
}
export function getFileNameToSiteIds(response) {
    const map = new Map();
    if (!response?.icfs) {
        return map;
    }
    for (const icf of response.icfs) {
        const existing = map.get(icf.icfFileName);
        const siteIds = existing ? `${existing}, ${icf.siteId}` : icf.siteId;
        map.set(icf.icfFileName, siteIds);
    }
    return map;
}
